import type { MainBanner } from '../../../domain/MainBanner'
import type { MainBannerDTO } from '../../../domain/MainBannerDTO'
import type { ContentMediaImage } from '../../../../content-media/domain/ContentMedia'
import { ContentModelId } from '../../../../../types/ContentModelId'

import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

import { mapEntryDTOList } from '../../../../../utils/map-entry-dto-list'

export const mapMainBannerFromApi = (dto: MainBannerDTO): MainBanner | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const { cards: cardsDTO, slideshow: slideshowDTO } = dto.fields

  const cards = mapEntryDTOList<ContentMediaImage>(cardsDTO) || []
  const slideshow = mapEntryDTOList<ContentMediaImage>(slideshowDTO) || []

  return {
    cards,
    contentType: ContentModelId.MAIN_BANNER,
    slideshow,
  }
}
